import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue
} from '@/components/ui/select'

export interface SelectOption {
    value: string
    label: string
}

interface SimpleSelectProps {
    value: string
    onValueChange: (value: string) => void
    options: SelectOption[]
    placeholder?: string
    id?: string
    className?: string
    size?: 'sm' | 'default'
    disabled?: boolean
    invalid?: boolean
    ariaLabel?: string
}

const SimpleSelect = ({
    value,
    onValueChange,
    options,
    placeholder = 'Select',
    id,
    className,
    size = 'default',
    disabled,
    invalid,
    ariaLabel
}: SimpleSelectProps): ReactNode => {
    return (
        <Select
            items={options}
            value={value || null}
            onValueChange={next => onValueChange(typeof next === 'string' ? next : '')}
            disabled={disabled}
        >
            <SelectTrigger
                id={id}
                size={size}
                aria-label={ariaLabel}
                aria-invalid={invalid || undefined}
                className={cn('w-full', className)}
            >
                <SelectValue placeholder={placeholder} />
            </SelectTrigger>

            <SelectContent>
                {options.map(option => (
                    <SelectItem key={option.value} value={option.value}>
                        {option.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    )
}

export default SimpleSelect
